import { render, staticRenderFns } from "./HelpManage.vue?vue&type=template&id=7528376e&"
import script from "./HelpManage.vue?vue&type=script&lang=js&"
export * from "./HelpManage.vue?vue&type=script&lang=js&"
import style0 from "./HelpManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports